var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpRequestMethod } from 'http-core-constants';
import { callService } from '../api';
export function logCriticalError(data) {
    return __awaiter(this, void 0, void 0, function* () {
        yield callService('api/monitoring/error', HttpRequestMethod.POST, {
            location: window.location.href,
            data
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JpdGljYWxFcnJvcnMuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsibW9uaXRvcmluZy9jcml0aWNhbEVycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxxQkFBcUIsQ0FBQTtBQUN2RCxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sUUFBUSxDQUFBO0FBRXBDLE1BQU0sVUFBZ0IsZ0JBQWdCLENBQUUsSUFBNkI7O1FBQ25FLE1BQU0sV0FBVyxDQUFDLHNCQUFzQixFQUFFLGlCQUFpQixDQUFDLElBQUksRUFBRTtZQUNoRSxRQUFRLEVBQUUsTUFBTSxDQUFDLFFBQVEsQ0FBQyxJQUFJO1lBQzlCLElBQUk7U0FDTCxDQUFDLENBQUE7SUFDSixDQUFDO0NBQUEifQ==